var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#323232",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.996,6.6h-4.201c-0.991,0 -1.795,0.804 -1.795,1.795v10.811c0,0.99 0.804,1.794 1.795,1.794h7.147c0.991,0 1.795,-0.804 1.795,-1.795v-0.763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.295,16.976l6.509,1.754c1.069,0.288 2.168,-0.347 2.453,-1.416l2.676,-10.044c0.282,-1.06 -0.353,-2.16 -1.412,-2.446l-6.509,-1.754c-1.069,-0.288 -2.168,0.347 -2.453,1.416l-2.676,10.044c-0.283,1.065 0.348,2.159 1.412,2.446Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,17.54l3.72,-13.9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24h-24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCards);
export default __webpack_public_path__ + "static/media/credit-cards.f467e9f0851e67cec8e91f9f2e03d71e.svg";
export { ForwardRef as ReactComponent };